import React from 'react';
import { useAuthStore } from '@/store/authStore';
import { RequestTabs } from './components/RequestTabs';
import { RequestDialog } from './components/RequestDialog';
import { PersonalInfoRequestDialog } from './components/PersonalInfoRequestDialog';
import { useRequests } from './hooks/useRequests';
import { usePersonalInfoRequests } from './hooks/usePersonalInfoRequests';

export function Requests() {
  const { 
    requests, 
    selectedRequest, 
    setSelectedRequest, 
    handleApprove, 
    handleReject 
  } = useRequests();

  const {
    requests: personalInfoRequests,
    selectedRequest: selectedInfoRequest,
    setSelectedRequest: setSelectedInfoRequest,
    handleApprove: handleInfoApprove,
    handleReject: handleInfoReject
  } = usePersonalInfoRequests();

  const user = useAuthStore((state) => state.user);
  const isAdmin = user?.role === 'admin';

  return (
    <div className="h-full flex flex-col">
      <div className="flex-shrink-0">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">الطلبات</h2>
      </div>

      <div className="flex-1 overflow-y-auto">
        <RequestTabs
          addRequests={requests}
          infoRequests={personalInfoRequests}
          isAdmin={isAdmin}
          onReviewAdd={setSelectedRequest}
          onRejectAdd={handleReject}
          onReviewInfo={setSelectedInfoRequest}
          onRejectInfo={handleInfoReject}
        />
      </div>

      {selectedRequest && (
        <RequestDialog
          request={selectedRequest}
          open={true}
          onClose={() => setSelectedRequest(null)}
          onApprove={handleApprove}
        />
      )}

      {selectedInfoRequest && (
        <PersonalInfoRequestDialog
          request={selectedInfoRequest}
          open={true}
          onClose={() => setSelectedInfoRequest(null)}
          onApprove={() => handleInfoApprove(selectedInfoRequest)}
          onReject={() => handleInfoReject(selectedInfoRequest.id)}
        />
      )}
    </div>
  );
}